module.exports = __webpack_public_path__ + "img/logo-1.5a8fc929.png";